/* eslint-disable jsx-a11y/anchor-is-valid */
import { FC, useContext, useEffect } from "react";
import { Link, useNavigate, NavLink } from "react-router-dom";

import DropdownStatusColorMeaning from "../dropdownStatusColorMeaning";

import { AuthContext } from "src/context/authContext";
import { LoaderContext } from "src/context/loaderContext";
import { ToastContext } from "src/context/toastContext";
import useFetch from "src/hooks/useFetch";

import { ExparelLogo } from "src/assets";
import { AuthenticatedHCPHeader, AuthenticatedManufactureHeader } from "src/constants/headerLinks";
import { HeaderElementType, ToastTypes } from "src/types";
import { APIEndpoints } from "src/types/apiTypes";
import { ResetDemoCasesAPISuccessResponseType } from "./types";
import { FAX_NUMBER } from "../../constants/contact";
import useDemoUserView from "src/hooks/useDemoUserVIew";
import useLogout from "src/hooks/useLogout";



const AuthHeader: FC = (): JSX.Element => {
  const navigate = useNavigate();
  const { userData, isManufacturer, isUserAuthorized } = useContext(AuthContext);
  const { setLoader,hideLoader } = useContext(LoaderContext);
  const { showToast } = useContext(ToastContext);
  const { submitForm: submitDemoUser } = useDemoUserView()

  const singleSignOn = localStorage.getItem("fromSingleSignOn")
  const { logoutUser } = useLogout()


  const { mutate: resetDemoCasesApi, data: resetDemoCasesApiResponse, error: resetDemoCasesApiResponseError } =
    useFetch<ResetDemoCasesAPISuccessResponseType>(APIEndpoints.DEMO_RESET_CASES);

  useEffect(() => {
    if (resetDemoCasesApiResponse?.status === 'success' || resetDemoCasesApiResponseError) {
      hideLoader();
      if (resetDemoCasesApiResponse?.status === 'success') {
        showToast([resetDemoCasesApiResponse.message], ToastTypes.SUCCESS);
        if (window.location.pathname === "/cases") {
          navigate(0)
        } else {
          navigate('/cases');
        }
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [resetDemoCasesApiResponse, resetDemoCasesApiResponseError]);

  const resetDemoCases = () => {
    setLoader()
    resetDemoCasesApi()
  }


  return (
    <nav className="navbar navbar-expand-lg p-3 pt-2 pb-2">
      <Link className="navbar-brand" to={isUserAuthorized ?
        (userData?.is_password_changed || singleSignOn ?
          (isManufacturer ? `/statistics` : `/cases`) :
          '/users/createuser'
        ) :
        `/users/sign_in`
      }
      >
        <img className="img-fluid after-login-logo" src={ExparelLogo} alt="Site logo" />
      </Link>
      <button className="navbar-toggler" type="button" data-bs-toggle="collapse" data-bs-target="#authHeader">
        <span className="navbar-toggler-icon"></span>
      </button>

      <div className="collapse navbar-collapse" id="authHeader">
        <ul className="navbar-nav me-auto first-nav align-items-lg-center">
          {userData?.is_password_changed || singleSignOn ? (
            <>
              {isManufacturer === true ?
                AuthenticatedManufactureHeader.map((headerLink, index) => (
                  <li
                    className={`nav-item ${headerLink.actionType === HeaderElementType.DRPODOWN ? 'dropdown' : ''}`}
                    key={index}
                  >
                    {headerLink.actionType === HeaderElementType.ROUTE ? (
                      <NavLink
                        className={({ isActive }) => {
                          return ["nav-link", isActive ? "custom-active-link" : ""].join(" ")
                        }}
                        aria-current="page"
                        to={headerLink.redirectLink}
                        end
                      >
                         {/* {headerLink.title === 'EOBs'
                          ? (userData?.ref_type === 'Manufacturer' || userData?.ref_type === 'fam_rm' ? headerLink.title : null)
                          : headerLink.title} */}
                          {headerLink.title}
                      </NavLink>
                    ) : null}
                    {headerLink.actionType === HeaderElementType.BUTTON ? (
                     headerLink.title === 'EOB Warehouse'
                        ? (userData?.ref_type === 'fam_rm' || userData?.eob_button) && (
                          <button className="btn btn-primary rounded-pill"
                                  onClick={() => navigate(headerLink.redirectLink)}>
                            {headerLink.title}
                          </button>
                        )
                        : (
                          <button
                            className="nav-link btn-primary rounded-pill"
                            onClick={() => navigate(headerLink.redirectLink)}
                          >
                            {headerLink.title}
                          </button>
                        )

                    ) : null}
                    {headerLink.actionType === HeaderElementType.LINK ? (
                      <a className="nav-link" href={headerLink.redirectLink} target="_blank" rel="noreferrer">
                        {headerLink.title}
                      </a>
                    ) : null}
                    {headerLink.actionType === HeaderElementType.DRPODOWN ? (
                      <>
                        <a
                          className="nav-link dropdown-toggle"
                          href="." data-bs-toggle="dropdown" aria-expanded="false"
                        >
                          {headerLink.title}
                        </a>
                        <ul className="resources-dropdown dropdown-menu dropdown-center">
                          {headerLink.dropdown && headerLink.dropdown.map((header, index) => (
                            <li key={index}>
                              <a
                                className="dropdown-item" href={header.redirectLink} target="_blank"
                                rel="noreferrer"
                              >
                                {header.title}
                              </a>
                            </li>
                          ))}
                        </ul>
                      </>
                    ) : null}
                  </li>
                ))
                :
                AuthenticatedHCPHeader.map((headerLink, index) => (
                  <li
                    className={`nav-item ${headerLink.actionType === HeaderElementType.DRPODOWN ? 'dropdown' : ''}`}
                    key={index}
                  >
                    {headerLink.actionType === HeaderElementType.ROUTE ? (
                      <NavLink
                        className={({ isActive }) => {
                          return ["nav-link", isActive ? "custom-active-link" : ""].join(" ")
                        }}
                        aria-current="page"
                        to={headerLink.redirectLink}
                        end
                      >
                      {headerLink.title}
                      </NavLink>
                    ) : null}
                    {headerLink.actionType === HeaderElementType.BUTTON ? 
                      ((headerLink.title === 'EOB Warehouse' ?
                        (userData && userData.eob_button ?
                          <button className="btn btn-primary rounded-pill"
                            onClick={() => {
                              navigate(headerLink.redirectLink)
                            }}
                          >
                            {headerLink.title}
                          </button>
                        : null)
                        :
                        (<button className="nav-link rounded-pill ms-0 ms-md-2"
                          onClick={() => {
                            navigate(headerLink.redirectLink)
                          }}
                        >
                          {headerLink.title}
                        </button>)
                      ))
                    : null}
                    {headerLink.actionType === HeaderElementType.LINK ? (
                      <a className="nav-link" href={headerLink.redirectLink} target="_blank" rel="noreferrer">
                        {headerLink.title}
                      </a>
                    ) : null}
                    {headerLink.actionType === HeaderElementType.DRPODOWN ? (
                      <>
                        <a className="nav-link dropdown-toggle" href="." data-bs-toggle="dropdown"
                          aria-expanded="false"
                        >
                          {headerLink.title}
                        </a>
                        <ul className="resources-dropdown dropdown-menu dropdown-center" style={{ top: '53px' }}>
                          {headerLink.dropdown && headerLink.dropdown.map((header, index) => (
                            <li key={index}>
                              <a className="dropdown-item" href={header.redirectLink} target="_blank" rel="noreferrer">
                                {header.title}
                              </a>
                            </li>
                          ))}
                        </ul>
                      </>
                    ) : null}
                  </li>
                ))
              }
            </>
          ) : null}
        </ul>

        <div className="text-start text-lg-end mt-3 mt-lg-0">
          <span><i className="bi bi-telephone"></i> 1-844-462-6225</span>
          <span className="ps-3"><i className="bi bi-printer"></i> {FAX_NUMBER}</span>
          <ul className="navbar-nav justify-content-end align-items-center">
            {singleSignOn ?
              (isManufacturer ? (
                <>
                  <li className="nav-item dropdown">
                    <a className="nav-link dropdown-toggle" href="." data-bs-toggle="dropdown"
                      aria-expanded="false"
                      role="button">
                      {userData?.name}
                    </a>
                    <ul className="dropdown-menu dropdown-menu-end">
                    <li><Link className="dropdown-item text-black" to='/users/updateuser'>Account
                            Settings</Link></li>
                      <li>
                        <button className="dropdown-item" onClick={() => submitDemoUser({ demo: true })}>
                          Demo User View
                        </button>
                      </li>
                      <li>
                        <hr className="dropdown-divider" />
                      </li>
                      <li><a className="dropdown-item text-black" onClick={logoutUser}>Logout</a></li>
                    </ul>
                  </li>
                </>
              ) : (
                  <>
                    <DropdownStatusColorMeaning />
                    <li className="nav-item dropdown">
                      <a className="nav-link dropdown-toggle" href="." data-bs-toggle="dropdown"
                        aria-expanded="false"
                        role="button">
                        {userData?.name}
                      </a>
                      <ul className="dropdown-menu dropdown-menu-end" style={{ minWidth: 182 }}>
                        <li><Link className="dropdown-item text-black" to='/users/updateuser'>Account
                          Settings</Link></li>
                        <li><Link className="dropdown-item text-black" to="/users/new">Add User</Link>
                        </li>
                        <li><Link className="dropdown-item text-black" to="/doctors/new">Add
                          Provider</Link></li>
                        <li>
                          <a
                            className="dropdown-item text-black"
                            href={`${window.location.protocol}//baa.${window.location.host}/pages?practice_name=${userData?.practice_name}&practice_address=${userData?.address}&practice_created_at=${userData?.practice_created_date}`}
                            target="_blank" rel="noreferrer"
                          >
                            BAA
                          </a>
                        </li>
                        {userData && userData.reset_demo_cases &&
                        <li>
                          <button className="dropdown-item" onClick={() => resetDemoCases()}>Reset Demo Cases</button>
                        </li>}
                        <li><button className="dropdown-item" onClick={() => submitDemoUser({ demo: false })}>Stats View</button></li>
                        <li>
                          <hr className="dropdown-divider" />
                        </li>
                        <li><button className="dropdown-item text-black" onClick={() => logoutUser()}>Logout</button></li>
                      </ul>
                    </li>
                  </>
                )
              )
              :
              (userData?.is_password_changed ? (
                <>
                  {isManufacturer ?
                    <>
                      <li className="nav-item dropdown">
                        <a className="nav-link dropdown-toggle" href="." data-bs-toggle="dropdown"
                          aria-expanded="false" role="button">
                          {userData?.name}
                        </a>
                        <ul className="dropdown-menu dropdown-menu-end">
                          <li><Link className="dropdown-item text-black" to='/users/updateuser'>Account
                            Settings</Link></li>
                          <li>
                            <hr className="dropdown-divider" />
                            {userData && (userData.demo_user_view || userData.stats_view) ? (
                              <li>
                                <button className="dropdown-item" onClick={() => submitDemoUser({ demo: true })}>
                                  Demo User View
                                </button>
                              </li>
                            ) : null}
                            {/* {userData && Object.hasOwn(userData, "demo_user_view") && userData.demo_user_view === true ? (
                                        <>
                                          <li><button className="dropdown-item" onClick={() => resetDemoCasesApi()}>Reset Demo Cases</button></li>
                                          <li><button className="dropdown-item" onClick={() => submitDemoUser({ demo: false })}>Stats View</button></li>
                                        </>
                                      ) : null} */}
                          </li>
                          <li><button className="dropdown-item text-black"
                            onClick={logoutUser}>Logout</button></li>
                        </ul>
                      </li>
                    </> :
                    <>
                      <DropdownStatusColorMeaning />
                      <li className="nav-item dropdown">
                        <a className="nav-link dropdown-toggle" href="." data-bs-toggle="dropdown"
                          aria-expanded="false"
                          role="button">
                          {userData?.name}
                        </a>
                        <ul className="dropdown-menu dropdown-menu-end">
                          <li><Link className="dropdown-item text-black" to="/users/updateuser">Account
                            Settings</Link></li>
                          <li><Link className="dropdown-item text-black" to="/users/new">Add User</Link>
                          </li>
                          <li><Link className="dropdown-item text-black" to="/doctors/new">Add
                            Provider</Link></li>
                          <li>
                            <a
                              className="dropdown-item text-black"
                              href={`${window.location.protocol}//baa.${window.location.host}/pages?practice_name=${userData.practice_name}&practice_address=${userData.address}&practice_created_at=${userData.practice_created_date}`}
                              target="_blank" rel="noreferrer"
                            >
                              BAA
                            </a>
                          </li>
                          {userData && userData.reset_demo_cases &&
                            <li><button className="dropdown-item" onClick={()=>resetDemoCases()}>Reset Demo Cases</button></li>
                          }
                          {userData && userData.stats_view ? (
                            <li><button className="dropdown-item" onClick={() => submitDemoUser({ demo: false })}>Stats View</button></li>
                          ) : null}
                          <hr className="dropdown-divider" />
                          <li><button className="dropdown-item text-black"
                            onClick={logoutUser}>Logout</button>
                          </li>
                        </ul>
                      </li>
                    </>
                  }
                </>
              ) : (
                <li className="nav-item dropdown">
                  <a className="nav-link dropdown-toggle" href="." data-bs-toggle="dropdown"
                    aria-expanded="false"
                    role="button">
                    {userData?.name}
                  </a>
                  <ul className="dropdown-menu dropdown-menu-end">
                    <li>
                      <hr className="dropdown-divider" />
                    </li>
                    <li><button className="dropdown-item text-black" onClick={logoutUser}>Logout</button></li>
                  </ul>
                </li>
              )
              )}
          </ul>
        </div>
      </div>
    </nav>
  );
};

export default AuthHeader;
